/*
 * Menus déroulants dans la navigation principale.
 *
 * Ghost ne gère pas nativement les sous-menus, mais on peut les créer
 * grâce à une convention de nommage dans « Settings → Navigation » :
 *
 *   - Un élément de menu « normal » reste un élément de premier niveau.
 *   - Un élément dont le libellé commence par un tiret suivi d'une espace
 *     ( « - Analyses », « — Entretiens », etc.) devient un sous-élément,
 *     rattaché à l'élément de premier niveau qui le précède.
 *
 * Exemple de menu (colonne « Label » dans Ghost) :
 *   Publications            → #  (ou une page réelle)
 *   - Analyses              → /tag/analyses/
 *   - Entretiens            → /tag/entretiens/
 *   L'association           → #
 *   - Notre mission         → /a-propos/
 *   - Équipe                → /equipe/
 *   - Partenariats          → /partenariats/
 */

/* Tiret / puce acceptés comme marqueur de sous-élément */
var NAV_CHILD_PATTERN = /^\s*(?:[-–—›»•·])\s+(.*)$/;

function navBuildSubmenus(nav) {
    var items = Array.prototype.slice.call(nav.children);
    var currentParent = null;
    var currentSubmenu = null;

    items.forEach(function (item) {
        // Ignore les éléments déjà traités (parents ou déjà dans un sous-menu)
        if (item.classList.contains('gh-has-submenu') || item.closest('.gh-submenu')) {
            currentParent = item.classList.contains('gh-has-submenu') ? item : currentParent;
            return;
        }

        var link = item.querySelector('a');
        var rawLabel = link ? link.textContent : item.textContent;
        var match = rawLabel.match(NAV_CHILD_PATTERN);

        if (match) {
            if (!currentParent) return;
            if (!currentSubmenu) {
                currentSubmenu = document.createElement('ul');
                currentSubmenu.className = 'gh-submenu';
                currentParent.classList.add('gh-has-submenu');
                currentParent.appendChild(currentSubmenu);
            }
            if (link) link.textContent = match[1];
            currentSubmenu.appendChild(item);
        } else {
            currentParent = item;
            currentSubmenu = null;
        }
    });

    // Ajoute le chevron sur chaque parent (sans doublon)
    nav.querySelectorAll('.gh-has-submenu').forEach(function (parent) {
        var link = parent.querySelector(':scope > a');
        if (link && !link.querySelector('.gh-submenu-caret')) {
            var caret = document.createElement('span');
            caret.className = 'gh-submenu-caret';
            caret.setAttribute('aria-hidden', 'true');
            link.appendChild(caret);
        }
    });
}

function navSubmenu() {
    var menus = document.querySelectorAll('.gh-navigation-menu .nav');
    if (!menus.length) return;

    menus.forEach(function (nav) {
        navBuildSubmenus(nav);

        // Délégation sur l'élément <nav> : le gestionnaire survit aux
        // reconstructions du menu (dropdown.js le régénère au redimensionnement).
        nav.addEventListener('click', function (e) {
            var link = e.target.closest('a');
            if (!link) return;
            var li = link.parentElement;
            if (!li || !li.classList.contains('gh-has-submenu') || link.parentElement !== li) return;

            var href = link.getAttribute('href');
            var hasTarget = href && href !== '#' && href !== '';
            var isMobile = window.matchMedia('(max-width: 767px)').matches;

            if (!hasTarget) {
                // Parent sans lien réel : le clic ouvre/ferme le sous-menu
                e.preventDefault();
                li.classList.toggle('is-open');
            } else if (isMobile && !li.classList.contains('is-open')) {
                // Sur mobile, premier tap = ouverture ; second tap = navigation
                e.preventDefault();
                li.classList.add('is-open');
            }
        });
    });

    // Après une reconstruction du menu par dropdown.js, on s'assure que les
    // sous-menus sont bien reconstitués si besoin.
    window.addEventListener('resize', function () {
        setTimeout(function () {
            document.querySelectorAll('.gh-navigation-menu .nav').forEach(function (nav) {
                if (!nav.querySelector('.gh-submenu')) navBuildSubmenus(nav);
            });
        }, 10);
    });
}
